import { gql } from "@apollo/client";
import { GlobalSettingsNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const GLOBAL_SETTINGS_KEY = "__GLOBAL_SETTINGS_KEY__";

const RemovalAiDetailsFragment = gql`
  fragment RemovalAiDetails on GlobalSettings {
    removalAiDetails {
      apiKey
    }
  }
`;

export const GlobalSettingsQuery = gql`
  ${RemovalAiDetailsFragment}
  ${GlobalSettingsNoNestingFragment}
  query globalSettings {
    globalSettings {
      ...GlobalSettingsNoNesting
      ...RemovalAiDetails
    }
  }
`;

export const MUTATION_UPDATE_GLOBAL_SETTINGS = gql`
  ${RemovalAiDetailsFragment}
  ${GlobalSettingsNoNestingFragment}
  mutation updateGlobalSettings($input: UpdateGlobalSettingsInput!) {
    updateGlobalSettings(input: $input) {
      ...GlobalSettingsNoNesting
      ...RemovalAiDetails
    }
  }
`;
